import React from "react";
import * as ai from "react-icons/ai";
import * as bs from "react-icons/bs";
import * as box from "react-icons/bi";
import * as ci from "react-icons/ci";
import * as cg from "react-icons/cg";
import * as di from "react-icons/di";
import * as fa from "react-icons/fa";
import * as fi from "react-icons/fi";
import * as fc from "react-icons/fc";
import * as fa5 from "react-icons/fa";
import * as fa6 from "react-icons/fa6";
import * as gi from "react-icons/gi";
import * as go from "react-icons/go";
import * as gr from "react-icons/gr";
import * as hi from "react-icons/hi";
import * as hi2 from "react-icons/hi2";
import * as im from "react-icons/im";
import * as lia from "react-icons/lia";
import * as io from "react-icons/io";
import * as io5 from "react-icons/io5";
import * as iu from "react-icons/lu";
import * as md from "react-icons/md";
import * as pi from "react-icons/pi";
import * as rx from "react-icons/rx";
import * as ri from "react-icons/ri";
import * as si from "react-icons/si";
import * as sl from "react-icons/sl";
import * as tb from "react-icons/tb";
import * as tfi from "react-icons/tfi";
import * as ti from "react-icons/ti";
import * as vsc from "react-icons/vsc";
import * as wi from "react-icons/wi";
const ICON_SETS = {
  ai,
  bs,
  box,
  ci,
  cg,
  di,
  fa,
  fi,
  fc,
  fa5,
  fa6,
  gi,
  go,
  gr,
  hi,
  hi2,
  im,
  lia,
  io,
  io5,
  iu,
  md,
  pi,
  rx,
  ri,
  si,
  sl,
  tb,
  tfi,
  ti,
  vsc,
  wi,
};
export const getIcon = (
  iconName,
  iconSet = "ai",
  size = 20,
  color = "#fff"
) => {
  const SelectedSet = ICON_SETS[iconSet];
  const IconComponent = SelectedSet?.[iconName];

  if (!IconComponent) return null;

  return <IconComponent size={size} color={color} />;
};
